var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "figure",
    { staticClass: "cms-image-block", style: _vm.figureStyle },
    [
      _vm.src
        ? _c(
            "img",
            _vm._b(
              {
                staticClass: "cms-image-block__img",
                style: _vm.imgStyle,
                attrs: { alt: _vm.alt },
              },
              "img",
              _vm.imgAttrs,
              false
            )
          )
        : _c("div", { staticClass: "cms-image-block__placeholder" }, [
            _c("i", { staticClass: "fa fa-picture-o" }),
            _vm._v(" "),
            _c("span", [_vm._v("No image set")]),
          ]),
      _vm._v(" "),
      _vm.caption || _vm.creditText
        ? _c("figcaption", { staticClass: "cms-image-block__caption" }, [
            _vm.caption ? _c("span", [_vm._v(_vm._s(_vm.caption))]) : _vm._e(),
            _vm._v(" "),
            _vm.creditText
              ? _c("small", { staticClass: "cms-image-block__credit" }, [
                  _vm._v(_vm._s(_vm.creditText)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }